import SendThreadEmail from 'actions/composition/lib/send_thread_email';

// Sends the task panel's reply draft into the task's side conversation.
export default class SendTaskThreadReply extends SendThreadEmail {
  postEmail(composed, email) {
    return this.context.gateways.taskThreadMessages.add(
      { taskId: composed.taskId },
      {
        channel: 'EMAIL',
        dueAt: composed.dueAt,
        email,
      }
    );
  }
}
